import Component from '../lib/component';

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props };

    // Track the click events
    this.clickHandler = this.clickHandler.bind(this);
    document.addEventListener('DOMContentLoaded', () => {
      const app = document.getElementById('inputs');
      app.addEventListener('click', this.clickHandler);
    });
  }

  clickHandler(event) {
    event.preventDefault();

    const {
      data: { componentName },
    } = this.state;

    // Get event target element and its parent
    const target = event.target || event.srcElement;
    if (!target) return;
    const parent = target.parentElement || target.parentNode;
    if (!parent) return;

    // Check if an action button for this component was clicked
    if (target.getAttribute('data-source') === componentName || parent.getAttribute('data-source') === componentName) {
      // Get the action
      const action = target.getAttribute('data-action') || parent.getAttribute('data-action');

      switch (action) {
        case 'increment': // If it's the increment button, call increment method
          this.increment();
          break;
        case 'decrement': // If it's the decrement button, call decrement method
          this.decrement();
          break;
        default:
      }
    }
  }

  // Increment value one steps if the value is smaller than max prop
  increment() {
    const {
      data: { value, max, steps },
    } = this.state;
    if (value < max) {
      this.setState({ value: value + steps });
    }
  }

  // Decrement value one steps if the value is bigger than min prop
  decrement() {
    const {
      data: { value, min, steps },
    } = this.state;
    if (value > min) {
      this.setState({ value: value - steps });
    }
  }

  // Define the template elements
  template(props) {
    const { componentName, value, unit, unitIsDegree, max, min } = props;
    this.temp = `
        <div class="rpc-section__counter">
          <!-- Counter - label -->
          <div class="rpc-section__counter-label">
            <dt class="rpc-section__counter-text">${value}</dt>
            <dd class="rpc-section__counter-unit${unitIsDegree ? '' : '--text'}">${unit}</dd>
          </div>
          <!-- Counter - arrows -->
          <div class="rpc-section__counter-arrows">
            <button type="button" data-source="${componentName}" data-action="increment" ${value >= max ? 'disabled' : ''}>
              <img src="assets/images/icon-thin-chevron-up.svg" />
            </button>
            <button type="button" data-source="${componentName}" data-action="decrement" ${value <= min ? 'disabled' : ''}>
              <img src="assets/images/icon-thin-chevron-down.svg" />
            </button>
          </div>
        </div>
      `;

    return this.temp;
  }
}

export default Counter;
